import { Text, VStack } from '@direct-frontend/components';
import { DrawerButton, DrawerHeader } from '@/shared/components/Drawer';

const NO_PHONE_URL = 'https://id.yandex.ru/security/phones';

export const LoyaltyRegistrationNoPhoneContent = () => (
    <VStack gap="16">
        <DrawerHeader title="Для учетной записи не задан номер телефона" />

        <Text size="mc">Добавьте номер телефона в Яндекс Паспорте</Text>
    </VStack>
);

export const LoyaltyRegistrationNoPhoneButton = () => (
    <DrawerButton href={NO_PHONE_URL} target="_blank">
        Перейти в Яндекс Паспорт
    </DrawerButton>
);
